import React from 'react';
import './PetAnimations.css';

export default function ClockworkSentinelSvg({ size = 120, color, className = '' }) {
  const brass = color || '#C9883F';
  const brassLight = '#E6B370';
  const brassDark = '#8A5A22';
  const steel = '#6E7686';
  const steelDark = '#3F4654';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Back gear (peeking) */}
      <g transform="translate(86 38)">
        <circle r="10" fill={steel} />
        <circle r="3" fill={steelDark} />
        <g fill={steel}>
          <rect x="-2" y="-13" width="4" height="6" />
          <rect x="-2" y="7" width="4" height="6" />
          <rect x="-13" y="-2" width="6" height="4" />
          <rect x="7" y="-2" width="6" height="4" />
          <rect x="-2" y="-13" width="4" height="6" transform="rotate(45)" />
          <rect x="-2" y="7" width="4" height="6" transform="rotate(45)" />
          <rect x="-13" y="-2" width="6" height="4" transform="rotate(45)" />
          <rect x="7" y="-2" width="6" height="4" transform="rotate(45)" />
        </g>
      </g>
      {/* Legs */}
      <rect x="42" y="92" width="10" height="14" rx="2" fill={steel} />
      <rect x="68" y="92" width="10" height="14" rx="2" fill={steel} />
      <rect x="40" y="104" width="14" height="4" rx="1" fill={steelDark} />
      <rect x="66" y="104" width="14" height="4" rx="1" fill={steelDark} />
      {/* Body */}
      <rect x="34" y="56" width="52" height="40" rx="6" fill={brass} />
      <rect x="34" y="56" width="52" height="40" rx="6" fill="none" stroke={brassDark} strokeWidth="1.5" />
      {/* Body highlight */}
      <rect x="38" y="60" width="12" height="28" rx="3" fill={brassLight} opacity="0.5" />
      {/* Chest gauge */}
      <circle cx="60" cy="76" r="9" fill={brassLight} />
      <circle cx="60" cy="76" r="9" fill="none" stroke={brassDark} strokeWidth="1.2" />
      <path d="M60 76L65 71" stroke={steelDark} strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="60" cy="76" r="1.5" fill={steelDark} />
      {/* Side rivets */}
      <circle cx="38" cy="62" r="1.5" fill={brassDark} />
      <circle cx="82" cy="62" r="1.5" fill={brassDark} />
      <circle cx="38" cy="90" r="1.5" fill={brassDark} />
      <circle cx="82" cy="90" r="1.5" fill={brassDark} />
      {/* Arms */}
      <rect x="22" y="62" width="10" height="22" rx="3" fill={brass} />
      <rect x="88" y="62" width="10" height="22" rx="3" fill={brass} />
      <circle cx="27" cy="86" r="5" fill={steel} />
      <circle cx="93" cy="86" r="5" fill={steel} />
      {/* Head */}
      <rect x="42" y="22" width="36" height="32" rx="4" fill={brass} />
      <rect x="42" y="22" width="36" height="32" rx="4" fill="none" stroke={brassDark} strokeWidth="1.5" />
      {/* Head highlight */}
      <rect x="44" y="24" width="8" height="22" rx="2" fill={brassLight} opacity="0.4" />
      {/* Eyes (glowing) */}
      <circle cx="52" cy="36" r="4" fill="#0A0E18" />
      <circle cx="68" cy="36" r="4" fill="#0A0E18" />
      <circle cx="52" cy="36" r="2.5" fill="#FFE08C" />
      <circle cx="68" cy="36" r="2.5" fill="#FFE08C" />
      <circle cx="52.5" cy="35" r="0.8" fill="white" />
      <circle cx="68.5" cy="35" r="0.8" fill="white" />
      {/* Mouth grille */}
      <rect x="50" y="44" width="20" height="5" rx="1" fill={steelDark} />
      <line x1="54" y1="44" x2="54" y2="49" stroke={brass} strokeWidth="0.8" />
      <line x1="58" y1="44" x2="58" y2="49" stroke={brass} strokeWidth="0.8" />
      <line x1="62" y1="44" x2="62" y2="49" stroke={brass} strokeWidth="0.8" />
      <line x1="66" y1="44" x2="66" y2="49" stroke={brass} strokeWidth="0.8" />
      {/* Antenna */}
      <line x1="60" y1="22" x2="60" y2="14" stroke={steel} strokeWidth="1.5" />
      <circle cx="60" cy="12" r="2.5" fill="#FF6644" />
    </svg>
  );
}
